module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-Light.6a7b8249.otf";